/* eslint-disable radix */
/* eslint-disable array-callback-return */
/* eslint-disable react/button-has-type */
import React, { useState, useContext } from "react";
import { UmbracoContext } from "../../components/Umbraco/UmbracoContext";
import utils from "../../utils";
import "./Header.scss";
import HeaderLobby from "../../containers/Lobby/components/headerLobby";
import logoImage from "images/Header/logo_manager_transparent_whiteTxt.png";
import { isMobile } from "react-device-detect";
import { Between, Line, Paragraph, Row } from "meitav-uikit";

const { UmbracoUtills } = utils;

const Header = (lobby) => {
  const resource =
    useContext(UmbracoContext).footerHeader.data.header.Properties;
  const [biggerFont, setBiggerFont] = useState(false);
  const [styleDark, setStyleDark] = useState(false);

  const fontResize = () => {
    setBiggerFont(!biggerFont);
    if (!biggerFont) {
      const elements = document.querySelectorAll("*");
      Object.keys(elements).map((element, i) => {
        const elementSize = window.getComputedStyle(elements[i]).fontSize;
        if (elementSize) {
          const k = parseInt(elementSize);
          const bigSize = (k * 106) / 100;
          elements[i].style.fontSize = `${bigSize}px`;
        }
      });
    } else {
      const elements = document.querySelectorAll("*");
      Object.keys(elements).map((element, i) => {
        const elementSize = window.getComputedStyle(elements[i]).fontSize;
        if (elementSize) {
          const k = parseInt(elementSize);
          const orgSize = (k * 99.5) / 100;
          elements[i].style.fontSize = `${orgSize}px`;
        }
      });
    }
  };
  const makeContrast = () => {
    var css =
      "html {-webkit-filter: invert(100%);" +
      "-moz-filter: invert(100%);" +
      "-o-filter: invert(100%);" +
      "-ms-filter: invert(100%); }";
    var head = document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    if (!window.counter) {
      window.counter = 1;
    } else {
      window.counter++;
      if (window.counter % 2 === 0) {
        var css =
          "html {-webkit-filter: invert(0%); -moz-filter: invert(0%); -o-filter: invert(0%); -ms-filter: invert(0%); }";
      }
    }
    style.type = "text/css";
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    head.appendChild(style);
  };

  // const classes = useStyles();
  return (
    // <JoinHeader logo='manager'/>
    <Line container className="headerContainer">
      <Row className="logoWrapper">
        <img src={logoImage} className="logoImgClass" alt="לוגו"></img>
      </Row>
      <Between className="accessibilityWrapper">
        {lobby.lobby && !isMobile ? <HeaderLobby /> : null}

        <span className="contatUs">
          <Paragraph>
            {UmbracoUtills.getValueByKey(resource, "contactUsPhone")}
          </Paragraph>
        </span>
        <div className="delimiter"></div>
        <button
          onClick={makeContrast}
          title="Contrast"
          className="icon-contrast accessibility"
        />
        <div className="delimiter"></div>
        <button
          onClick={fontResize}
          title="הגדל/הקטן גודל גופן"
          className="icon-accessibility accessibility"
        />
      </Between>
      {lobby.lobby && isMobile ?
        <div
          justifyContent="center"
          width="100%"
          padding="8px"
        >
          <HeaderLobby />
        </div>
        : <></>
      }

    </Line>
  );
};
export default Header;
